<template>
  <div>
    <template v-if="editSoaIndex === index && !soa.isAutoSoa">
      <div class="bb-table-body-select">
        <custom-select :list="list"
                       @setValue="setValue"
                       :default-val="modeOfPayment || expenseCategory"
                       :table-mode="true"/>
      </div>
    </template>
    <template v-else>
      {{soa.modeOfPayment ? soa.modeOfPayment.name : ''}}
    </template>
  </div>
</template>

<script>
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
export default {
  name: 'ModeOfPaymentColumn',
  components: {CustomSelect},
  props: ['list', 'index', 'editSoaIndex', 'soa', 'modeOfPayment', 'expenseCategory'],
  methods: {
    setValue (item) {
      this.soa.modeOfPayment = item.id
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../../sass/variables";
  @import "../../../../../../../../sass/mixins";
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableSoA/Columns/ModeOfPaymentColumn.vue